import { mergeRight } from 'ramda'

const defaultState = {
  imports: []
}

const imports = (state = defaultState, action) => {
  switch (action.type) {
    case 'RECEIVE_IMPORTS':
      return mergeRight(state, {
        imports: action.imports
      })

    default:
      return state
  }
}

export default imports